import Divider from '@/components/Divider';
import { AuthorEntity, ComponentCommonAuthorDetailed } from '@/graphql/generated/graphql';
import { useResponsiveImage } from '@/utils/useResponsiveImage';
import classNames from 'classnames';

function AuthorImage({ author }: { author: AuthorEntity }) {
  const { src, alt } = useResponsiveImage(author?.attributes?.avatar);
  return (
    <img
      src={src}
      alt={alt}
      className="h-20 w-20 grow rounded-full border-4 border-primary-500 object-cover object-center"
    />
  );
}

export default function DefaultContentTemplateAuthorDetailed({
  component,
  className,
}: {
  component: ComponentCommonAuthorDetailed;
  className?: string;
}) {
  return (
    <>
      {component?.authors?.data?.map((author, index) => {
        return (
          <>
            <div className={classNames('grid grid-cols-[80px_auto] gap-4', className)} key={author?.id}>
              <div>
                <AuthorImage author={author} />
              </div>

              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-1 text-center">
                  <p className="text-sh-xxs font-semibold">{author?.attributes?.name},</p>
                  <p className="mt-0 text-sh-xxs">{author?.attributes?.role}</p>
                </div>

                <p className="text-sh-xxs">{author?.attributes?.bio}</p>
              </div>
            </div>
            {(component?.authors?.data?.length || 0) > index + 1 ? <Divider isBody /> : null}
          </>
        );
      })}
    </>
  );
}
